export default function SectionHeading({ eyebrow, title, sub, center = false }) {
    return (
        <div className={center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
            {eyebrow && <p className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent">{eyebrow}</p>}
            <h2 className="mt-3 text-3xl tracking-tight text-foreground sm:text-4xl">{title}</h2>
            {sub && <p className="mt-4 text-lg text-muted-foreground">{sub}</p>}
        </div>
    );
}
